<p>share-payment-link works!</p>
